import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsIdentificationNeeded, selectIsPublishToHiddenBase } from '../../selectors/publishAvailable';
import { NeedIdentification } from '../NeedIdentification';
import { HiddenBaseContainer } from '../HiddenBase';
import { Device } from '../common/Device';
import { SummaryDesktop } from './components/SummaryDesktop';
import { SummaryMobile } from './components/SummaryMobile';

export const SummaryContainer = () => {
  const isIdentificationNeeded = useSelector(selectIsIdentificationNeeded);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);

  if (isIdentificationNeeded) {
    return <NeedIdentification />;
  }

  if (isPublishToHiddenBase) {
    return <HiddenBaseContainer />;
  }

  return <Device mobile={<SummaryMobile />} desktop={<SummaryDesktop />} />;
};

// `displayName` не соответствует названию react-контейнера, так как блок является сегментом.
// Сегменты управляются `ad-segment.service` и для корректной работы имя должно быть с префиксом `cian-af-`.
SummaryContainer.displayName = 'cianAfSummary';
